import * as types from "../ActionType";
import axios from "axios";
import { notifyError,notifysuccess , staticc } from "../../Components/General/Notification";

const getAbout = (about) => {
    return ({
        type: types.GET_ABOUT,
        payload: about
    })
}
const editAbout = () => {
    return ({
        type: types.EDIT_ABOUT
    })
}
const getPrivacy = (privacy) => {
    return ({
        type: types.GET_PRIVACY,
        payload: privacy
    })
}
const editPrivacy = () => {
    return ({
        type: types.EDIT_PRIVACY
    })
}

export const loadAbout = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/about`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getAbout(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const updateAbout = (content, setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        console.log(content)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/about-update?content=${content}`,{}, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(editAbout());
                dispatch(loadAbout());
                notifysuccess(res.data.message)
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data.message)
        })
    }
}

export const loadPrivacy = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/privacy`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getPrivacy(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const updatePrivacy = (content, setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/privacy-update`,{content}, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(editPrivacy());
                dispatch(loadPrivacy());
                notifysuccess(res.data.message)
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data.message)
        })
    }
}